(() => {
  const productIngredientsEls = document.querySelectorAll('[data-product-ingredients]');

  const init = () => {
    if (!window.productIngredientsInit) {
      window.productIngredientsInit = true;

      Array.from(productIngredientsEls).forEach((productIngredientsEl) => {
        const popupToggleEls = productIngredientsEl.querySelectorAll('[data-product-ingredients-popup-toggle]');
        const popupEl = productIngredientsEl.querySelector('[data-product-ingredients-popup]');

        Array.from(popupToggleEls).forEach((popupToggleEl) => {
          popupToggleEl.addEventListener('click', handlePopupToggle);
        });

        popupEl.addEventListener('click', handlePopupClick);
      });

      initSlider();
    }
  }

  const handlePopupToggle = (event) => {
    const popupToggleEl = event.target;

    popupToggleEl.closest('[data-product-ingredients]').classList.toggle('popup-open');
  }

  const handlePopupClick = (event) => {
    const popupEl = event.target;

    if (popupEl.classList.contains('product-ingredients__popup')) {
      popupEl.closest('[data-product-ingredients]').classList.remove('popup-open');
    }
  }

  const initSlider = () => {
    const slider = tns({
      container: '[data-product-ingredients-slider]',
      items: 1,
      edgePadding: 12,
      gutter: 12,
      nav: false,
      mouseDrag: true,
      swipeAngle: false,
      loop: true,
      responsive: {
        1: {
          disable: false
        },
        741: {
          disable: true
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();